import CreateProjets from './landing-ilustrations/create-projects'
import WeeklyProjects from './landing-ilustrations/weekly-projects'
import PixelPerfect from './landing-ilustrations/pixel-perfect'
import ShareSuccess from './landing-ilustrations/share-success'

const ProjectsSections = [
  {
    title: 'Crea un portafolio excelente',
    description: 'Aprende todo lo necesario y muestra tus habilidades al mundo con un portafolio y proyectos profesionales.',
    cta: {
      text: 'Ver proyectos',
      link: '/proyectos/todos',
    },
    icon: 'folder-icon',
    ilustration: <CreateProjets />,
    reverse: false,
    align: 'flex-start',
    background: true,
    backgroundStyles: `
      transform: rotate(180deg);
      bottom: -100px;
      z-index: -2;
    `,
    marginBottom: 128,
  },
  {
    title: 'Proyectos nuevos cada semana',
    description: [
      'Diseños profesionales y retadores',
      'Buenas practicas y trucos en cada reto',
      'Todos los proyectos cuentan con un design system',
      'Registra tu avance y muestra tus prototipos desde el perfil',
    ],
    cta: {
      text: 'Ver proyectos',
      link: '/proyectos/todos',
    },
    icon: 'project-week-icon',
    ilustration: <WeeklyProjects />,
    reverse: true,
    background: true,
    backgroundStyles: `
      top: 0;
    `,
    marginBottom: 80,
  },
  {
    title: 'Pixel Perfect',
    description: 'Construye proyectos apoyándote de colores, fuentes, tamaños, distancia entre elementos e incluso propiedades de CSS, que te ayudarán a implementar diseños de calidad.',
    cta: {
      text: 'Ver proyectos',
      link: '/proyectos/todos',
    },
    icon: 'pixel-perfect-icon',
    ilustration: <PixelPerfect />,
    reverse: false,
  },
  {
    title: 'Comparte tu éxito',
    description: 'Forma parte de nuestro canal privado de Discord, donde podrás compartir conocimiento con más estudiantes, mentees y creadores.',
    cta: {
      text: '',
      link: '',
    },
    icon: 'discord-icon',
    ilustration: <ShareSuccess />,
    reverse: true,
    background: true,
    backgroundStyles: `
      transform: rotate(180deg);
      bottom: 0;
    `,
    marginBottom: 277,
  },
]

export default ProjectsSections
